// src/pages/AdminPanel.js
import React, { useState, useEffect } from 'react';
import './AdminPanel.css';

const kategoriler = {
  "Vidalı Kompresörler": [
    "MI Serisi Kayış - Kasnaklı",
    "MIT Serisi Depo Üzeri Kabinli",
    "MITK Serisi Depo Üzeri Kabinli ve Kurutuculu",
    "D Plus Serisi Direkt Akuple",
    "D Premium Serisi Direkt Akuple Yüksek Verimli",
    "DHK Plus Direkt Akuple İnvertörlü",
    "DHK Premium Direkt Akuple İnvertörlü Yüksek Verimli",
    "DHK EVO Serisi İki Kademeli",
    "D EVO Serisi İki Kademeli",
    "AIROMAK Serisi Yüksek Verimli Yağ Soğutmalı"
  ],
  "Pistonlu Kompresörler": [
    "LKD Serisi",
    "Booster Kompresörler",
    "Benzin Motorlu Kompresör"
  ],
  "Yağsız Kompresörler": [
    "Yağsız Pistonlu Kompresörler",
    "Yağsız Scroll Kompresörler",
    "Yağsız Yüksek Basınç LYPS Serisi (PET Kompresörü)",
    "Yağsız Alçak Basınç LYPS Serisi (PET Kompresörü)",
    "Yağsız CO₂ Kompresörleri"
  ],
  "Turbo Kompresörler": [
    "P300",
    "P400",
    "P500",
    "P600",
    "P700"
  ],
  "Kurutucular": [
    "Soğutmalı Compac Serisi",
    "Soğutmalı Compac-P Serisi",
    "Soğutmalı MKE Serisi",
    "Soğutmalı MKP Serisi",
    "Kimyasal AKDAB Serisi",
    "Kimyasal AKDAC Serisi",
    "Kimyasal MDA Serisi",
    "LAD Serisi"
  ],
  "Hava Tankları": [
    "Alçak Basınç",
    "Yüksek Basınç"
  ],
  "Ekipmanlar": [
    "Yağ Buhar Ayırıcı",
    "Aktif Karbon Kulesi",
    "Isı Geri Kazanımı",
    "Oransal Kontrol Valfi",
    "Merkezi Kontrol Sistemi",
    "Yağ Isıtıcı",
    "Uzaktan İzlenebilme",
    "Su Seperatörü",
    "Otomatik Tahliye",
    "Soft Starter",
    "Su Soğutma"
  ]
};

const AdminPanel = () => {
  const [formData, setFormData] = useState({
    id: '', kategori: '', altKategori: '', baslik: '', aciklama: '', detay: '', resim: '',
    teknik: {}, genelOzellikler: [], varyantlar: []
  });

  const [teknikKey, setTeknikKey] = useState('');
  const [teknikValue, setTeknikValue] = useState('');
  const [ozellik, setOzellik] = useState('');
  const [topluOzellik, setTopluOzellik] = useState('');
  const [varyant, setVaryant] = useState({ model: '', basinc: '', kapasite: '', motor_kw: '', motor_hp: '' });
  const [topluVaryant, setTopluVaryant] = useState('');
  const [mesaj, setMesaj] = useState('');
  const [liste, setListe] = useState([]);

  // JSON dosyasından veri yükle
  useEffect(() => {
    fetch('/urunler.json')
      .then(res => res.json())
      .then(data => {
        if (data.urunler && data.urunler.length > 0) {
          setListe(data.urunler);
          localStorage.setItem('urunler', JSON.stringify(data.urunler)); // localStorage'a da yaz
        } else {
          const kayitli = JSON.parse(localStorage.getItem('urunler') || '[]');
          setListe(kayitli);
        }
      })
      .catch(err => {
        console.warn("urunler.json okunamadı, localStorage kullanılıyor:", err);
        const kayitli = JSON.parse(localStorage.getItem('urunler') || '[]');
        setListe(kayitli);
      });
  }, []);

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleKategoriChange = e => {
    const yeniKategori = e.target.value;
    setFormData({ ...formData, kategori: yeniKategori, altKategori: '' });
  };

  const handleAddTeknik = () => {
    if (teknikKey && teknikValue) {
      setFormData(prev => ({
        ...prev,
        teknik: { ...prev.teknik, [teknikKey]: teknikValue }
      }));
      setTeknikKey('');
      setTeknikValue('');
    }
  };

  const handleAddOzellik = () => {
    if (ozellik.trim()) {
      setFormData(prev => ({
        ...prev,
        genelOzellikler: [...prev.genelOzellikler, ozellik.trim()]
      }));
      setOzellik('');
    }
  };

  const handleBulkOzellikEkle = () => {
    const satirlar = topluOzellik.split('\n').map(s => s.trim()).filter(Boolean);
    if (satirlar.length > 0) {
      setFormData(prev => ({
        ...prev,
        genelOzellikler: [...prev.genelOzellikler, ...satirlar]
      }));
      setTopluOzellik('');
    }
  };

  const handleAddVaryant = () => {
    if (varyant.model && varyant.basinc && varyant.kapasite && varyant.motor_kw && varyant.motor_hp) {
      setFormData(prev => ({
        ...prev,
        varyantlar: [...prev.varyantlar, varyant]
      }));
      setVaryant({ model: '', basinc: '', kapasite: '', motor_kw: '', motor_hp: '' });
    }
  };

  const handleBulkVaryantEkle = () => {
    const satirlar = topluVaryant.trim().split('\n');
    const yeniVaryantlar = satirlar.map(satir => {
      const [model, basinc, kapasite, motor_kw, motor_hp] = satir.split('|').map(s => s.trim());
      if (model && basinc && kapasite && motor_kw && motor_hp) {
        return { model, basinc, kapasite, motor_kw, motor_hp };
      }
      return null;
    }).filter(Boolean);
    if (yeniVaryantlar.length > 0) {
      setFormData(prev => ({
        ...prev,
        varyantlar: [...prev.varyantlar, ...yeniVaryantlar]
      }));
      setTopluVaryant('');
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    const guncel = [...liste, formData];
    localStorage.setItem('urunler', JSON.stringify(guncel));
    setListe(guncel);
    setMesaj('✅ Ürün başarıyla eklendi.');
    setFormData({
      id: '', kategori: '', altKategori: '', baslik: '', aciklama: '', detay: '', resim: '',
      teknik: {}, genelOzellikler: [], varyantlar: []
    });
  };

  const handleSil = (id) => {
    const yeniListe = liste.filter(u => u.id !== id);
    setListe(yeniListe);
    localStorage.setItem('urunler', JSON.stringify(yeniListe));
    setMesaj('🗑️ Ürün silindi.');
  };

  // JSON indirme fonksiyonu
  const handleVerileriIndir = () => {
    const urunler = localStorage.getItem('urunler');
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(urunler);
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", "urunler.json");
    document.body.appendChild(downloadAnchorNode);
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  };

  return (
    <div className="admin-panel">
      <h2>Admin Panel – Yeni Ürün Ekle</h2>
      <form onSubmit={handleSubmit}>
        <input name="id" placeholder="Benzersiz ID" value={formData.id} onChange={handleChange} required />
        <select name="kategori" value={formData.kategori} onChange={handleKategoriChange} required>
          <option value="">Kategori Seç</option>
          {Object.keys(kategoriler).map((kat, i) => (
            <option key={i} value={kat}>{kat}</option>
          ))}
        </select>
        <select name="altKategori" value={formData.altKategori} onChange={handleChange} required>
          <option value="">Alt Kategori Seç</option>
          {(kategoriler[formData.kategori] || []).map((alt, i) => (
            <option key={i} value={alt}>{alt}</option>
          ))}
        </select>
        <input name="baslik" placeholder="Başlık" value={formData.baslik} onChange={handleChange} required />
        <input name="aciklama" placeholder="Kısa Açıklama" value={formData.aciklama} onChange={handleChange} required />
        <input name="resim" placeholder="/images/xxx.jpg" value={formData.resim} onChange={handleChange} required />
        <textarea name="detay" placeholder="Detaylı Açıklama" value={formData.detay} onChange={handleChange} rows={4} />

        {/* Teknik Özellik Ekle */}
        <div className="teknik-ekle">
          <input placeholder="Teknik Adı" value={teknikKey} onChange={e => setTeknikKey(e.target.value)} />
          <input placeholder="Teknik Değeri" value={teknikValue} onChange={e => setTeknikValue(e.target.value)} />
          <button type="button" onClick={handleAddTeknik}>Teknik Özellik Ekle</button>
        </div>

        {/* Eklenen Teknik Özellikler */}
        {Object.keys(formData.teknik).length > 0 && (
          <div style={{ marginTop: '10px' }}>
            <h4>⚙️ Eklenen Teknik Özellikler</h4>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
              <tbody>
                {Object.entries(formData.teknik).map(([key, value], i) => (
                  <tr key={i}>
                    <td style={{ border: '1px solid #ccc', padding: '6px', fontWeight: 600 }}>{key}</td>
                    <td style={{ border: '1px solid #ccc', padding: '6px' }}>{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Genel Özellik Ekle */}
        <div className="teknik-ekle">
          <input placeholder="Genel Özellik" value={ozellik} onChange={e => setOzellik(e.target.value)} />
          <button type="button" onClick={handleAddOzellik}>Genel Özellik Ekle</button>
        </div>

        {/* Toplu Genel Özellik Ekle */}
        <div className="teknik-ekle">
          <textarea
            placeholder="Her satıra bir genel özellik yaz (toplu ekleme)"
            value={topluOzellik}
            onChange={e => setTopluOzellik(e.target.value)}
            rows={4}
            style={{ width: '100%', marginTop: 6 }}
          />
          <button type="button" onClick={handleBulkOzellikEkle}>Toplu Genel Özellik Ekle</button>
        </div>

        {/* Eklenen Genel Özellikler */}
        {formData.genelOzellikler.length > 0 && (
          <div style={{ marginTop: '10px' }}>
            <h4>✅ Eklenen Genel Özellikler</h4>
            <ul style={{ paddingLeft: 20 }}>
              {formData.genelOzellikler.map((ozellik, i) => (
                <li key={i} style={{ marginBottom: 5 }}>🟢 {ozellik}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Toplu Varyant Ekle */}
        <div className="teknik-ekle">
          <textarea
            placeholder="Model | Basınç | Kapasite | kW | HP (her satıra bir varyant)"
            value={topluVaryant}
            onChange={e => setTopluVaryant(e.target.value)}
            rows={4}
          />
          <button type="button" onClick={handleBulkVaryantEkle}>Toplu Varyant Ekle</button>
        </div>

        {/* Eklenen Varyantlar Tablosu */}
        {formData.varyantlar.length > 0 && (
          <table className="varyant-tablo">
            <thead>
              <tr style={{ textAlign: 'center' }}>
                <th>Model</th>
                <th>Max Çalışma Basıncı (g)</th>
                <th>Kapasite SHV* (m³/dk)</th>
                <th>Motor (kW)</th>
                <th>Motor (HP)</th>
              </tr>
            </thead>
            <tbody>
              {formData.varyantlar.map((v, i) => (
                <tr key={i}>
                  <td>{v.model}</td>
                  <td>{v.basinc}</td>
                  <td>{v.kapasite}</td>
                  <td>{v.motor_kw}</td>
                  <td>{v.motor_hp}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <button type="submit">Ürünü Kaydet</button>
      </form>

      {/* JSON indir butonu */}
      <button type="button" onClick={handleVerileriIndir} style={{ marginTop: '20px' }}>
        📥 Verileri JSON Olarak İndir (urunler.json)
      </button>

      {mesaj && <p className="mesaj">{mesaj}</p>}

      <hr />
      <h3>📦 Mevcut Ürünler ({liste.length})</h3>
      <ul className="liste">
        {liste.map((u, i) => (
          <li key={i}>
            <strong>{u.baslik}</strong> <em>({u.kategori} / {u.altKategori})</em>
            <button onClick={() => handleSil(u.id)}>Sil</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AdminPanel;